import * as React from "react";
import { forwardRef } from "react";
const SvgForwardedIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.54553 2V5.1245C6.87317 5.12458 2 5.15572 2 14C2.5525 8.0857 5.09061 8.04851 9.54553 8.04845V11.4606L14 6.72992L9.54553 2Z", fill: "#ECFAFF" }));
const ForwardRef = forwardRef(SvgForwardedIcon);
export { ForwardRef as ReactComponent };
